import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect, useMemo } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import ReactPaginate from "react-paginate";

const authUrl = process.env.REACT_APP_API_ENDPOINT_AUTH;
const jobsUrl = process.env.REACT_APP_API_ENDPOINT_JOBS;
const clientId = process.env.REACT_APP_API_CLIENT_ID;
const secret = process.env.REACT_APP_API_SECRET;

function App() {
  const [showLoader, setShowLoader] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [jobPositionCity, setJobPositionCity] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState("");
  const [jobPositionTitle, setJobPositionTitle] = useState([]);
  const [selectedTitleId, setSelectedTitleId] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  const [itemOffsetEffectiveJobs, setItemOffsetEffectiveJobs] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3;
  const endOffsetEffectiveJobs = itemOffsetEffectiveJobs + itemsPerPage;

  const filteredJobs = useMemo(() => {
    return jobs.filter((job) => {
      const matchesCity =
        !selectedCityId || job.cityId === Number(selectedCityId);

      const matchesTitle =
        !selectedTitleId || job.titlePositionId === Number(selectedTitleId);

      return matchesCity && matchesTitle;
    });
  }, [jobs, selectedCityId, selectedTitleId]);

  const currentEffectiveJobs = filteredJobs.slice(
    itemOffsetEffectiveJobs,
    endOffsetEffectiveJobs,
  );

  const pageCountEffectiveJobs = Math.ceil(filteredJobs.length / itemsPerPage);

  const handlePageClickEffectiveJobs = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filteredJobs.length;
    setItemOffsetEffectiveJobs(newOffset);
    setCurrentPage(event.selected);

    document.getElementById("oportunidades").scrollIntoView();
  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  const closeMenu = () => {
    setShowMenu(false);
  };

  const generateNonce = () => {
    const nonce = Math.floor(Math.random() * 1000000000);
    return nonce;
  };

  const generateTimestamp = () => {
    const timestamp = Math.floor(Date.now() / 1000).toString();
    return timestamp;
  };

  const onChangeFilterJobsCity = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedCityId($event.target.value);
  };

  const onChangeFilterJobsTitle = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedTitleId($event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);

      let retries = 0;
      let success = false;

      while (retries <= 2 && !success) {
        try {
          let token = localStorage.getItem("api_token");
          let storedNonce =
            localStorage.getItem("api_nonce") || generateNonce();
          let storedTimestamp =
            localStorage.getItem("api_timestamp") || generateTimestamp();

          if (!token) {
            const authResponse = await fetch(`${authUrl}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Nonce": storedNonce,
                "X-Timestamp": storedTimestamp,
              },
              body: JSON.stringify({
                clientId: clientId,
                secret: secret,
              }),
            });

            if (!authResponse.ok) throw new Error("Erro na autenticação");

            const authData = await authResponse.json();
            token = authData.token;

            localStorage.setItem("api_token", token);
            localStorage.setItem("api_nonce", storedNonce);
            localStorage.setItem("api_timestamp", storedTimestamp);
          }

          const dataResponse = await fetch(`${jobsUrl}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-Target": "philipmorris",
              "X-Nonce": storedNonce,
              "X-Timestamp": storedTimestamp,
            },
          });

          if (dataResponse.status === 401) {
            localStorage.clear();

            retries++;
            continue;
          }

          if (!dataResponse.ok) throw new Error("Erro ao buscar dados");

          const jobsData = await dataResponse.json();

          setJobs(jobsData.jobPositionList);
          setJobPositionCity(jobsData.cityList);
          setJobPositionTitle(jobsData.titlePositionList);

          success = true;
        } catch (error) {
          console.error("Erro no fluxo:", error);
          retries++;
        }
      }

      setShowLoader(false);
    };

    fetchData();
  }, []);

  return (
    <div onMouseDown={closeMenu}>
      <nav className="bg-[#2074D9] h-25">
        <div className="flex items-center justify-between p-4 pr-[10%] relative">
          <div>
            <img
              src="./assets/icons/randstad-logo.png"
              alt="Philips Morris Logo"
              className="h-26"
            />
          </div>

          <div
            className="burguer-menu cursor-pointer mb-1"
            onClick={toggleMenu}
          >
            <img
              src="./assets/icons/Menu.svg"
              alt="menu"
              className="rounded-none"
            />
          </div>

          <ul
            id="content-burger-menu"
            className={`${"flex flex-row justify-end items-center gap-16 list-meu w-1/2"} ${
              showMenu ? "show" : ""
            }`}
          >
            <li>
              <a href="#sobre" className="text-white">
                sobre nós
              </a>
            </li>
            <li>
              <a href="#oportunidades" className="text-white">
                oportunidades
              </a>
            </li>
            <li>
              <a
                href="https://www.randstad.com.br/contate-nos/contato-candidato/"
                target="_blank"
                className="text-white"
                rel="noreferrer"
              >
                contato
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="w-full bg-[#2074D9] flex justify-center items-center">
        <div className="w-1/2 max-[768px]:w-full">
          <img
            src="./assets/images/landing-image-1.png"
            alt="Philips Morris"
            className="w-full"
          />
        </div>
        <div
          id="main-title"
          className="flex flex-col items-start z-10 w-1/2 max-[768px]:hidden"
        >
          <p className="text-white text-7xl font-regular ml-[-8%] max-[768px]:text-xl">
            trabalhe
          </p>
          <p className="text-white text-7xl font-regular ml-[12%] max-[768px]:text-xl">
            conosco
          </p>
          <p className="text-white text-3xl font-regular ml-[40%] max-[768px]:text-sm max-[768px]:ml-[30%]">
            na
          </p>
          <p className="text-white text-7xl font-regular ml-[2%] max-[768px]:text-xl">
            Philip Morris
          </p>
        </div>
      </div>

      <div className="flex flex-wrap w-full bg-white py-14 px-[7vw]">
        <h1 className="text-3xl text-blue-500 font-light mb-6">
          Parceria com a Philip Morris e Randstad
        </h1>
        <div
          id="parceria"
          className="w-full flex flex-row gap-6 max-[768px]:flex-col"
        >
          <div className="flex items-center w-1/2 gap-[15%] max-[768px]:w-full">
            <img
              src="./assets/images/philips-morris.png"
              alt="Logo Philips Morris"
              className="w-[50%]"
            />
            <img
              src="https://kraftheinz.randstad.com.br/vagas_kraftheinz/img/vagas_kraftheinz.svg.svg"
              alt="Logo Randstad"
              className="w-[20%]"
            />
          </div>
          <div className="w-1/2 flex max-[768px]:w-full">
            <p className="text-black text-lg">
              A Philip Morris, em parceria com a Randstad, líder global em
              recrutamento e soluções completas de recursos humanos, presente em
              mais de 39 países pelo mundo, uniu forças para garantir um
              processo seletivo que, além de selecionar talentos, também
              apresenta como é trabalhar em uma renomada empresa de tabaco. A
              Philip Morris International (PMI) é uma das líderes globais na
              indústria do tabaco, com uma força de trabalho global de
              aproximadamente 82.700 colaboradores.
            </p>
          </div>
        </div>
      </div>

      <div
        className="flex w-full gap-6 py-14 px-[7vw] max-[768px]:flex-col !pt-0 justify-center items-center"
        id="sobre"
      >
        <div className="flex flex-col w-1/2 max-[768px]:w-full">
          <h1 className="text-3xl font-light text-blue-500 mb-4">
            sobre a Philip Morris
          </h1>
          <p className="text-lg text-black">
            Com sede em Lausanne - Suiça,  e listada na Bolsa de Valores de Nova
            York (NYSE: PM), a Philip Morris International (PMI) está moldando
            seu futuro ao substituir cigarros tradicionais por produtos de risco
            reduzido. Embora esses novos produtos não sejam isentos de riscos,
            representam uma alternativa mais saudável em comparação ao cigarro
            convencional.
          </p>
          <p className="text-lg text-black">
            Essa transformação é a maior na história da empresa e beneficia
            consumidores, acionistas e a sociedade em geral. Com base em ciência
            e inovação, e apoiada pela regulamentação adequada e pelo suporte da
            sociedade civil, a PMI está comprometida a alcançar sua visão de um
            futuro sem fumaça mais rapidamente.
          </p>
          <p className="text-lg text-black">
            Cinco das 15 maiores marcas internacionais, vendidas em mais de 180
            mercados, pertencem à Philip Morris International (PMI), que conta
            com 50 centros de produção.
          </p>
          <p className="text-lg text-black mb-6">
            Seus produtos são preferidos por 150 milhões de consumidores ao
            redor do mundo. Para aqueles que optam por continuar fumando, a PMI
            segue comprometida em oferecer produtos da mais alta qualidade.
          </p>
          <a href="#oportunidades" className="w-[350px]">
            <button className="bg-[#2074D9] text-white w-full h-[60px] rounded-sm hover:bg-blue-600 max-[768px]:w-full">
              Clique aqui e confira nossas vagas
            </button>
          </a>
        </div>

        <div className="w-1/2 h-auto max-[768px]:w-full">
          <img
            src="./assets/images/landing-image-5.png"
            alt="Philips Morris"
            className="w-full"
          />
        </div>
      </div>

      <div
        id="proposito"
        className="w-full flex flex-row mb-16 gap-6 px-[7vw] justify-center items-center"
      >
        <div className="w-[50%] max-[768px]:w-full">
          <img
            src="./assets/images/landing-image-2.png"
            alt="Philips Morris"
            className="w-full h-[80%]"
          />
        </div>

        <div className="w-[50%] flex flex-col max-[768px]:w-full">
          <h1 className="text-3xl font-light text-blue-500 mb-4">
            Missão da Philip Morris
          </h1>
          <div className="space-y-2 mb-6">
            <p className="text-lg text-black">
              A empresa está determinada a realizar uma transformação
              significativa: substituir os cigarros convencionais por produtos
              sem fumaça, atualmente desenvolvidos e comercializados em mais de
              70 mercados. Para isso, a PMI conta com mais de 1.586 cientistas,
              engenheiros e técnicos em seus centros de pesquisa e
              desenvolvimento na Suíça e em Singapura, dedicados ao
              desenvolvimento de alternativas potencialmente menos prejudiciais
              que os cigarros.
            </p>
          </div>
          <p className="text-lg text-black mb-6">
            A missão da Philip Morris International (PMI) é atuar como uma
            empresa social e ambientalmente responsável, dedicando-se a combater
            o comércio ilícito de cigarros. A PMI apoia com orgulho as
            comunidades de onde provém seu tabaco e onde seus colaboradores
            vivem e trabalham.
          </p>
        </div>
      </div>

      <div
        id="dna"
        className="flex w-full gap-6 py-14 px-[7vw] max-[768px]:flex-col !pt-0 justify-center items-center"
      >
        <div className="w-[60%] flex flex-col max-[768px]:w-full">
          <h1 className="text-3xl font-light text-blue-500 mb-4">PMI DNA</h1>
          <div className="space-y-2 mb-6">
            <p className="text-lg text-black">
              Três valores fundamentais e comportamentos. A ambição para a nossa
              cultura é clara: trazer o melhor da PMI. Quando todos dentro da
              PMI abraçam todo o seu potencial, alcançamos todo o nosso
              potencial como negócio.
            </p>
            <p className="text-lg text-black">
              Nosso PMI DNA é reflexo de nós quando estamos em nosso melhor,
              destacando nossos pontos fortes e nossas aspirações. Ao colocar
              nosso DNA em ação no dia a dia, mostraremos uns aos outros, e ao
              mundo, nossa verdadeira natureza e potencial.
            </p>
            <p className="text-lg text-black mb-6">
              Nos nossos melhores dias, sempre demonstramos esse DNA. Quando
              nossos melhores dias se tornam nosso dia-a-dia, somos imparáveis.
            </p>
          </div>

          <h1 className="text-3xl font-light text-blue-500 mb-4">
            A gente se importa
          </h1>
          <p className="text-lg text-black">
            Fazemos a coisa certa – para hoje e para o futuro. Estamos
            determinados a criar um impacto positivo para aqueles que nos
            rodeiam, assim como fazemos para nossos consumidores em nossa missão
            de oferecer um futuro sem fumaça. Conscientes do nosso impacto nos
            outros, gerimos as nossas emoções, ouvimos, somos intencionais e
            inclusivos nas nossas ações.
          </p>
          <p className="text-lg text-black mb-6">
            Usamos nosso poder coletivo para moldar um ambiente onde todos
            prosperamos.
          </p>
        </div>

        <div className="w-[40%] max-[768px]:w-full">
          <img
            src="./assets/images/landing-image-3.png"
            alt="Philips Morris"
            className="w-full h-[90%]"
          />
        </div>
      </div>

      <h1 className="text-3xl font-light text-blue-500 mb-4 px-[7vw]">
        comportamentos
      </h1>
      <div className="flex flex-wrap gap-6 mb-12 px-[7vw] max-[768px]:flex-col">
        <div className="h-auto bg-[#F7F5F0] flex-1 rounded-lg">
          <h1 className="text-lg font-light text-blue-500 mb-4 text-center mt-4">
            AUTOCONHECIMENTO
          </h1>
          <p className="text-black text-center px-4">
            Conhecer a nós mesmos, ter consciência do impacto que temos nas
            outras pessoas, gerir as nossas emoções e comportamentos para ter
            sucesso.
          </p>
        </div>
        <div className="h-auto bg-[#F7F5F0] flex-1 rounded-lg">
          <h1 className="text-lg font-light text-blue-500 mb-4 text-center mt-4">
            INCLUSÃO
          </h1>
          <p className="text-black text-center px-4">
            Pesquisar, ouvir e aprender intencionalmente a partir de diferentes
            perspectivas para alcançar os melhores resultados.
          </p>
        </div>
        <div className="h-auto bg-[#F7F5F0] flex-1 rounded-lg">
          <h1 className="text-lg font-light text-blue-500 mb-4 text-center mt-4">
            EMPATIA
          </h1>
          <p className="text-black text-center px-4">
            Agir com cuidado, compreender as outras pessoas e demonstrar
            sensibilidade às suas necessidades.
          </p>
        </div>
      </div>

      <div
        id="somos-melhores"
        className="flex w-full gap-6 py-14 px-[7vw] max-[768px]:flex-col !pt-0 justify-center items-center"
      >
        <div className="w-[40%] max-[768px]:w-full">
          <img
            src="./assets/images/landing-image-4.png"
            alt="Philips Morris"
            className="w-full h-[90%]"
          />
        </div>

        <div className="w-[60%] flex flex-col max-[768px]:w-full flex-1">
          <h1 className="text-3xl font-light text-blue-500 mb-4">
            Somos melhores juntos
          </h1>
          <div className="space-y-2 mb-6">
            <p className="text-lg text-black">
              Nosso legado é construída sobre relacionamentos, confiança e
              colaboração. Para continuar cumprindo nossas ambições ousadas,
              temos a disciplina de deixar de lado egos, quebrar silos e nos
              unir como uma PMI. Somos curiosos. Cientes de que nossos pontos
              fortes podem ser diferentes, buscamos perspectivas diversas,
              reconhecemos e celebramos as contribuições uns dos outros. A nossa
              competição é fora, não dentro, aprendemos em equipe e ganhamos em
              equipe.
            </p>
          </div>
        </div>
      </div>

      <h1 className="text-3xl font-light text-blue-500 mb-4 px-[7vw]">
        comportamentos
      </h1>
      <div className="flex flex-wrap gap-6 mb-12 px-[7vw] max-[768px]:flex-col">
        <div className="h-auto bg-[#F7F5F0] flex-1 rounded-lg">
          <h1 className="text-lg font-light text-blue-500 mb-4 text-center mt-4">
            CONFIANÇA
          </h1>
          <p className="text-black text-center px-4">
            Conquistar e manter a confiança por meio de nossas ações,
            transparência, sinceridade e comunicação aberta.
          </p>
        </div>
        <div className="h-auto bg-[#F7F5F0] flex-1 rounded-lg">
          <h1 className="text-lg font-light text-blue-500 mb-4 text-center mt-4">
            COLABORAÇÃO
          </h1>
          <p className="text-black text-center px-4">
            Ter disciplina para deixar de lado nossos egos, quebrar silos, focar
            no longo prazo e nos unir por um propósito compartilhado.
          </p>
        </div>
        <div className="h-auto bg-[#F7F5F0] flex-1 rounded-lg">
          <h1 className="text-lg font-light text-blue-500 mb-4 text-center mt-4">
            CELEBRAÇÃO
          </h1>
          <p className="text-black text-center px-4">
            Celebrar nossos sucessos (grandes e pequenos), reconhecer e
            valorizar as contribuições de todos.
          </p>
        </div>
      </div>

      <div
        className="flex w-full gap-6 py-14 px-[7vw] max-[768px]:flex-col !pt-0 justify-center items-center"
        id="sobre"
      >
        <div className="flex flex-col w-1/2 max-[768px]:w-full">
          <h1 className="text-3xl font-light text-blue-500 mb-4">
            Mudamos o jogo
          </h1>
          <p className="text-lg text-black">
            Fazemos coisas que ninguém fez antes. Nossa principal força sempre
            foi nossa busca por resultados, que usamos para revolucionar nossa
            indústria e inovar. Assumimos riscos calculados, experimentamos e
            aprendemos com nossos erros. Somos curiosos, abertos a desafios e
            confiantes em nossa busca por impacto – uma combinação poderosa que
            nos torna imparáveis.
          </p>
        </div>

        <div className="w-1/2 h-auto max-[768px]:w-full">
          <img
            src="./assets/images/landing-image-5.png"
            alt="Philips Morris"
            className="w-full"
          />
        </div>
      </div>

      <h1 className="text-3xl font-light text-blue-500 mb-4 px-[7vw]">
        comportamentos
      </h1>
      <div className="flex flex-wrap gap-6 mb-12 px-[7vw] max-[768px]:flex-col">
        <div className="h-auto bg-[#F7F5F0] flex-1 rounded-lg">
          <h1 className="text-lg font-light text-blue-500 mb-4 text-center mt-4">
            ABRAÇAR DESAFIOS
          </h1>
          <p className="text-black text-center px-4">
            Agir com coragem e determinação para inovar e ser disruptivo.
          </p>
        </div>
        <div className="h-auto bg-[#F7F5F0] flex-1 rounded-lg">
          <h1 className="text-lg font-light text-blue-500 mb-4 text-center mt-4">
            AGILIDADE
          </h1>
          <p className="text-black text-center px-4">
            Ter iniciativa para assumir riscos calculados, experimentar, adaptar
            e aprender com os erros.
          </p>
        </div>
        <div className="h-auto bg-[#F7F5F0] flex-1 rounded-lg">
          <h1 className="text-lg font-light text-blue-500 mb-4 text-center mt-4">
            IMPACTO
          </h1>
          <p className="text-black text-center px-4">
            Agir com energia para alcançar resultados, fazer acontecer e gerar
            valor, apesar das adversidades.
          </p>
        </div>
      </div>

      <div className="w-full flex flex-col justify-center px-[7vw] mb-2 max-[768px]:mt-14">
        <h1 className="text-3xl font-light text-blue-500 mb-4">
          toda história tem um bom começo!
        </h1>
        <p className="text-lg text-black">
          Foi assim que a Randstad surgiu: de uma grande ideia, através de uma
          bicicleta.
        </p>
        <p className="text-lg text-black">
          Foi de bike que nosso fundador, lá na Holanda em 1960, levou a
          primeira candidata à sua entrevista de emprego. Hoje, a Randstad é
          líder global em recrutamento e soluções completas de recursos humanos.
        </p>
        <p className="text-lg text-black">
          A companhia combina o poder da tecnologia com o toque humano,
          oferecendo as melhores soluções para empresas e ajudando talentos a se
          manterem relevantes no mundo de trabalho em constante mudança. Está
          presente em mais de 39 países e empregando mais de 670 mil pessoas por
          dia, chegou ao Brasil em 2011, atendendo todas as regiões do país e
          conta com mais de 700 colaboradores.
        </p>
      </div>

      <div
        className="w-full flex flex-col justify-center py-14 px-[7vw]"
        id="oportunidades"
      >
        <h1 className="text-3xl font-light text-blue-500 mb-4">
          quer uma oportunidade? então faça sua inscrição!
        </h1>
        <div className="flex max-lg:flex-col justify-between max-lg:gap-4 w-full">
          <select
            onChange={onChangeFilterJobsCity}
            defaultValue=""
            className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
          >
            <option value="">Todas as cidades</option>
            {jobPositionCity.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name} {jobId.stateCode ? `- ${jobId.stateCode}` : ""}
              </option>
            ))}
          </select>
          <select
            onChange={onChangeFilterJobsTitle}
            defaultValue=""
            className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
          >
            <option value="">Todas os cargos</option>
            {jobPositionTitle.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name}
              </option>
            ))}
          </select>
        </div>
        {showLoader && (
          <div className="w-[90%] flex flex-col items-center mt-20 max-[1024px]:w-full">
            <Spinner animation="grow" variant="primary" />
            <h4 className="text-[#3b82f6] mt-4">Carregando</h4>
          </div>
        )}
        {!showLoader && currentEffectiveJobs.length ? (
          <>
            <ul>
              {currentEffectiveJobs.map((job, i) => (
                <li className="jobs-list" key={i}>
                  <div className="w-[70%] pl-3 max-[1024px]:w-full max-[1024px]:p-0">
                    <p className="!m-0 max-[1024px]:text-center">{job.name}</p>
                  </div>
                  <div className="w-[30%] flex justify-end max-[1024px]:w-full max-[1024px]:justify-center">
                    <Button
                      className="py-3 px-5 cursor-pointer self-end"
                      variant="primary"
                      href={job.shortUrl}
                      target="_blank"
                    >
                      candidatar-se
                    </Button>
                  </div>
                </li>
              ))}
            </ul>
            <ReactPaginate
              containerClassName="pagination"
              breakLabel="..."
              nextLabel="Próximo >"
              onPageChange={handlePageClickEffectiveJobs}
              marginPagesDisplayed={2}
              pageCount={pageCountEffectiveJobs}
              forcePage={currentPage}
              previousLabel="< Anterior"
              renderOnZeroPageCount={null}
            />
          </>
        ) : null}
        {!showLoader && !currentEffectiveJobs.length ? (
          <div className="jobs-list !justify-center">
            <h2 className="text-xl">
              Não encontramos resultados para sua busca.
            </h2>
          </div>
        ) : null}
      </div>

      <div className="bg-[#f7f5f0] px-[7vw] py-12">
        <p className="text-black text-2xl mb-8">
          Buscando dicas para a sua carreira? Confira nosso blog
        </p>
        <a
          href="https://www.randstad.com.br/guia-carreira/"
          target="_blank"
          className="border border-blue-500 text-blue-500 py-3 px-6 rounded-sm hover:bg-blue-500 hover:text-white transition"
          rel="noreferrer"
        >
          acesse nosso blog
        </a>
      </div>

      <footer className="bg-[#2074D9] text-white py-8">
        <div className="container mx-auto flex flex-col items-center md:flex-row md:justify-between px-4">
          <div className="mb-4 md:mb-0">
            <img
              src="./assets/icons/Logo.png"
              alt="Randstad Logo"
              className="h-12"
            />
          </div>

          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="mb-2">
              Randstad Brasil Recursos Humanos LTDA é uma empresa registrada no
              Brasil sob CNPJ 03.573.863/000
            </p>
            <p>
              Escritório da matriz encontra-se na Av. Francisco Matarazzo, 1350,
              20º andar / CEP: 05001-100
            </p>
            <p>
              A Randstad trata dados pessoais de acordo com a LGPD (Lei
              13.709/18). Leia nosso{" "}
              <a
                href="https://www.randstad.com.br/sobre-sua-privacidade/"
                target="_blank"
                className="text-white underline hover:no-underline"
                rel="noreferrer"
              >
                Aviso de Privacidade
              </a>
              .
            </p>
          </div>

          <div className="flex space-x-4">
            <a
              href="https://www.linkedin.com/company/randstad-brasil/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/linkedin-logo.png" alt="Linkedin Logo" />
            </a>
            <a
              href="https://www.youtube.com/user/randstadbrasil/featured"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/youtube-logo.png" alt="Youtube Logo" />
            </a>
            <a
              href="https://www.facebook.com/RandstadBR/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/facebook-logo.png" alt="Facebook Logo" />
            </a>
            <a
              href="https://www.instagram.com/randstadbr/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img
                src="./assets/icons/instagram-logo.png"
                alt="Instagram Logo"
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
